import { render } from "./GamedayRow.vue?vue&type=template&id=5998dce2&scoped=true"
import script from "./GamedayRow.vue?vue&type=script&lang=js"
export * from "./GamedayRow.vue?vue&type=script&lang=js"

import "./GamedayRow.vue?vue&type=style&index=0&id=5998dce2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5998dce2"]])

export default __exports__